<template>
  <div class="input">
    <div class="input-label">開始時間</div>
    <div class="input-group">
      <input type="number"  min="0" max="23" class="input-text" v-model="startHour">
      <div class="input-label_after">時</div>
      <input type="number"  min="0" max="59" class="input-text" v-model="startMinute">
      <div class="input-label_after">分</div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    startHour: {
      get: function () {
        return this.$store.state.event.startHour
      },
      set: function (value) {
        this.$store.commit(
          'event/setStartHour',
          value
        )
      }
    },

    startMinute: {
      get: function () {
        return this.$store.state.event.startMinute
      },
      set: function (value) {
        this.$store.commit(
          'event/setStartMinute',
          value
        )
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/_form.scss';
</style>
